import Cookies from 'js-cookie';

const LS_REFRESH_TOKEN = 'refresh_token';
const LS_EXPIRES_AT = 'token_expires_at';
const LS_REFRESH_EXPIRES_AT = 'token_refresh_expires_at';

export const setToken = (token) => {
  Cookies.set('token', token, {expires: 30 * 12}); // 1 tahun
}
export const getToken = () => Cookies.get('token')
export const isTokenExist = () => !!getToken()
export const removeToken = () => Cookies.remove('token')

// localStorage bisa throw (mis. Safari private mode / storage diblokir)
const setLocalItem = (key, value) => {
  try {
    if (value) {
      localStorage.setItem(key, value);
    } else {
      localStorage.removeItem(key);
    }
  } catch (_) {
    // abaikan
  }
}
const getLocalItem = (key) => {
  try {
    return localStorage.getItem(key) || null;
  } catch (_) {
    return null;
  }
}

/** JWT: refresh_token disimpan di localStorage */
export const setRefreshToken = (refreshToken) => setLocalItem(LS_REFRESH_TOKEN, refreshToken)
export const getRefreshToken = () => getLocalItem(LS_REFRESH_TOKEN)

/** JWT: waktu expired access token dari BE */
export const setExpiresAt = (expiresAt) => setLocalItem(LS_EXPIRES_AT, expiresAt)
export const getExpiresAt = () => getLocalItem(LS_EXPIRES_AT)

/** JWT: waktu expired refresh token dari BE */
export const setRefreshExpiresAt = (refreshExpiresAt) =>
  setLocalItem(LS_REFRESH_EXPIRES_AT, refreshExpiresAt)
export const getRefreshExpiresAt = () => getLocalItem(LS_REFRESH_EXPIRES_AT)

/** Hapus seluruh data autentikasi (access_token + refresh_token + expires_at) */
export const clearAuthTokens = () => {
  removeToken();
  setRefreshToken(null);
  setExpiresAt(null);
  setRefreshExpiresAt(null);
}

/**
 * Ganti SELURUH sesi dengan token baru (login / register / app-connect).
 * Field yang tidak dikirim BE ikut dikosongkan, supaya refresh_token sesi lama
 * (mis. user lain) tidak terpasang dengan access token sesi baru.
 */
export const setAuthTokens = ({
  access_token,
  refresh_token,
  expires_at,
  refresh_expires_at,
} = {}) => {
  if (access_token) {
    setToken(access_token);
  } else {
    removeToken();
  }
  setRefreshToken(refresh_token);
  setExpiresAt(expires_at);
  setRefreshExpiresAt(refresh_expires_at);
}

export const setSavedEmail = (email) => {
  Cookies.set('email', email, {expires: 30 * 12}); // 1 tahun
}
export const getSavedEmail = () => Cookies.get('email')
export const isEmailSavedExist = () => !!getSavedEmail()
export const removeSavedEmail = () => Cookies.remove('email')
